import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiRoutes } from '../../../shared/constants/api-routes';
import { InteractionRequest } from '../../models/requests/interaction-request';
import { StartQuemSouEuSessionRequest } from '../../models/requests/start-quem-sou-eu-session-request';
import { GiveUpResponse } from '../../models/responses/give-up-response';
import { InteractionResponse } from '../../models/responses/interaction-response';
import { QuemSouEuSessionResponse } from '../../models/responses/quem-sou-eu-session-response';

/** Todas as rotas do "Quem Sou Eu?" (`/quem-sou-eu/...`). Cada jogo tem o seu serviço HTTP. */
@Injectable({ providedIn: 'root' })
export class QuemSouEuApiService {
  private readonly http = inject(HttpClient);

  /** Cria a sessão do Modo Solo; já devolve a sessão completa (limites inclusos). */
  startSession(request: StartQuemSouEuSessionRequest): Observable<QuemSouEuSessionResponse> {
    return this.http.post<QuemSouEuSessionResponse>(ApiRoutes.quemSouEu.startSession(), request);
  }

  sendInteraction(idSession: string, request: InteractionRequest): Observable<InteractionResponse> {
    return this.http.patch<InteractionResponse>(
      ApiRoutes.quemSouEu.interaction(idSession),
      request,
    );
  }

  giveUp(idSession: string): Observable<GiveUpResponse> {
    return this.http.patch<GiveUpResponse>(ApiRoutes.quemSouEu.giveUp(idSession), null);
  }

  /** Cria a sessão do Desafio Diário do tema/dia (`date` em `yyyy-MM-dd`). Sem body. */
  startDailySession(idTheme: string, date: string): Observable<QuemSouEuSessionResponse> {
    return this.http.post<QuemSouEuSessionResponse>(
      ApiRoutes.quemSouEu.startDailySession(idTheme, date),
      null,
    );
  }

  /** Retoma uma sessão do Desafio Diário em andamento (não aceita sessões do Modo Solo). */
  getSession(idSession: string): Observable<QuemSouEuSessionResponse> {
    return this.http.get<QuemSouEuSessionResponse>(ApiRoutes.quemSouEu.getSession(idSession));
  }
}
